<template src="./List.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import SearchQuery from "@/components/competitors/components/SearchQuery"
import TopMenu from "@/components/competitors/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('competitors/list');

export default {
  name: "CompetitorsExcluded",
  components: {
    SearchQuery,
    TopMenu,
  },
  data() {
    return {
      showOverlay: false,
      timer: null,
    }
  },
  methods: {
    ...mapActions(['SAVE', 'GET_DATA']),
    change() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.SAVE({th: this})
      }, 1500)
    },
    getData() {
      this.GET_DATA({th: this})
    },
  },
  computed: {
    ...mapGetters([
      'COMPETITOR_LIST',
    ]),
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('competitors') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>